import { Injectable } from '@angular/core';
import { AuthService } from 'app/services/auth.service';

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  children?: ChildrenItems[];
}



const MENUITEMS: Menu[] = [
  {
    state: 'home',
    name: 'Dashboard',
    type: 'link',
    icon: 'home'
  },
  {
    state: 'report',
    name: 'Report',
    type: 'sub',
    icon: 'create',
    children: [
      { state: 'create-new-visura', name: 'Crea nuovo Visura' },
      { state: 'create-new-report', name: 'Crea nuovo report' },
      { state: 'report-history', name: 'Storico dei Report' },
      { state: 'candidate-list', name: 'Tutte le visure' }
    ]
  },
  {
    state: 'consumption',
    name: 'Fatturazione e Consumi',
    type: 'sub',
    icon: 'data_usage',
    children: [
      { state: 'month', name: 'Consumi del mese' },
      { state: 'pay', name: 'Consumi da pagare' },
      { state: 'all', name: 'Tutti i Consumi' }
    ]
  },
  {
    state: 'file',
    name: 'Carica o scarica File',
    type: 'sub',
    icon: 'cloud_upload',
    children: [
      { state: 'upload', name: 'Carica File' },
      { state: 'download', name: 'Scarica File' }
    ]
  },
  {
    state: 'profile',
    name: 'Informazioni Generali',
    type: 'sub',
    icon: 'person',
    children: [
      { state: 'personal', name: 'Informazioni personali' },
      { state: 'company', name: 'Informazioni aziendali' },
      { state: 'contract', name: 'Contratti firmati' },
      { state: 'password', name: 'Cambia password' }]
  },
  /* {
    state: 'tenant',
    name: 'Inquilino',
    type: 'sub',
    icon: 'tab',
    children: [
      {state: 'create-tenant', name: 'creare inquilino'},
      {state: 'lista-tenant', name: 'elenco inquilino'}  ]
  }, */
  /* {
    state: 'user',
    name: 'Users',
    type: 'sub',
    icon: 'person',
    children: [
      {state: 'list', name: 'list'}
    ]
  }, */
  {
    state: 'help',
    name: 'Aiuto',
    type: 'link',
    icon: 'help'
  },
  /* {
    state: 'emails',
    name: 'Emails',
    type: 'link',
    icon: 'mail'
  },
  {
    state: 'chat',
    name: 'CHAT',
    type: 'link',
    icon: 'chat_bubble_outline'
  },
  {
    state: 'features',
    name: 'FEATURES',
    type: 'sub',
    icon: 'library_books',
    children: [
      {state: 'colorpicker', name: 'COLOR PICKER'},
      {state: 'cropper', name: 'CROPPER'},
      {state: 'dragula', name: 'DRAGULA'},
      {state: 'sortable', name: 'SORTABLE'}
    ]
  },
  {
    state: 'components',
    name: 'COMPONENTS',
    type: 'sub',
    icon: 'local_activity',
    children: [
      {state: 'accordion', name: 'ACCORDION'},
      {state: 'alerts', name: 'ALERTS'},
      {state: 'buttons', name: 'BUTTONS'},
      {state: 'carousel', name: 'CAROUSEL'},
      {state: 'collapse', name: 'COLLAPSE'},
      {state: 'datepicker', name: 'DATEPICKER'},
      {state: 'dropdown', name: 'DROPDOWN'},
      {state: 'modal', name: 'MODAL'},
      {state: 'pagination', name: 'PAGINATION'},
      {state: 'popover', name: 'POPOVER'},
      {state: 'progressbar', name: 'PROGRESS BAR'},
      {state: 'rating', name: 'RATING'},
      {state: 'tabs', name: 'TABS'},
      {state: 'timepicker', name: 'TIMEPICKER'},
    ]
  },
  {
    state: 'icons',
    name: 'ICONS',
    type: 'sub',
    icon: 'center_focus_weak',
    children: [
      {state: 'linea', name: 'LINEA'},
      {state: 'font-awesome', name: 'FONT AWESOME'},
      {state: 'simple-line-icons', name: 'SIMPLE LINE ICONS'},
      {state: 'material-icons', name: 'MATERIAL ICONS'},
    ]
  },
  {
    state: 'cards',
    name: 'CARDS',
    type: 'sub',
    icon: 'grid_on',
    children: [
      {state: 'basic-cards', name: 'BASIC CARDS'},
      {state: 'advance-cards', name: 'ADVANCE CARDS'}
    ]
  },
  {
    state: 'forms',
    name: 'FORMS',
    type: 'sub',
    icon: 'format_align_justify',
    children: [
      {state: 'form-wizard', name: 'FORM CONTROLS'},
      {state: 'form-upload', name: 'UPLOAD'},
    ]
  },
  {
    state: 'tables',
    name: 'TABLES',
    type: 'sub',
    icon: 'grid_on',
    children: [
      {state: 'basic-tables', name: 'BASIC TABLES'},
      {state: 'responsive-tables', name: 'RESPONSIVE TABLES'}
    ]
  },
  {
    state: 'data-tables',
    name: 'DATA TABLES',
    type: 'sub',
    icon: 'format_line_spacing',
    children: [
      {state: 'selection', name: 'SELECTION'},
      {state: 'pinning', name: 'PINNING'},
      {state: 'sorting', name: 'SORTING'},
      {state: 'paging', name: 'PAGING'},
      {state: 'editing', name: 'EDITING'},
      {state: 'filter', name: 'FILTER'}
    ]
  },
  {
    state: 'chart',
    name: 'CHARTS',
    type: 'sub',
    icon: 'insert_chart',
    children: [
      {state: 'bar-charts', name: 'BAR'},
      {state: 'pie-charts', name: 'PIE'},
      {state: 'line-charts', name: 'LINE'},
      {state: 'mixed-charts', name: 'MIXED'},
      {state: 'ng2-charts', name: 'NG2 CHARTS'},
    ]
  },
    {
    state: 'maps',
    name: 'MAPS',
    type: 'sub',
    icon: 'map',
    children: [
      {state: 'googlemap', name: 'GOOGLE MAP'},
      {state: 'leafletmap', name: 'LEAFLET MAP'}
    ]
  },
    {
    state: 'pages',
    name: 'PAGES',
    type: 'sub',
    icon: 'web',
    children: [
      {state: 'about', name: 'ABOUT'},
      {state: 'contact', name: 'CONTACT'},
      {state: 'timeline', name: 'TIMELINE'},
      {state: 'pricing', name: 'PRICING'},
      {state: 'blank', name: 'BLANK'},
    ]
  },
  {
    state: 'user-pages',
    name: 'USERS',
    type: 'sub',
    icon: 'person',
    children: [
      {state: 'userlist', name: 'USER LIST'},
      {state: 'userprofile', name: 'USER PROFILE'},
    ]
  },
  {
    state: 'authentication',
    name: 'AUTHENTICATION',
    type: 'sub',
    icon: 'security',
    children: [
      {state: 'login', name: 'LOGIN'},
      {state: 'register', name: 'REGISTER'},
      {state: 'forgot-password', name: 'FORGOT'},
      {state: 'lockscreen', name: 'LOCKSCREEN'}
    ]
  },
  {
    state: 'error',
    name: 'ERROR',
    type: 'sub',
    icon: 'error_outline',
    children: [
      {state: '404', name: '404'},
      {state: '503', name: '503'}
    ]
  },
  {
    state: 'calendar',
    name: 'CALENDAR',
    type: 'link',
    icon: 'date_range'
  },
  {
    state: 'media',
    name: 'MEDIA',
    type: 'sub',
    icon: 'perm_media',
    children: [
      {state: 'grid', name: 'GRID'},
      {state: 'list', name: 'LIST'}
    ]
  },
  {
    state: 'editor',
    name: 'EDITOR',
    type: 'sub',
    icon: 'format_shapes',
    children: [
      {state: 'ckeditor', name: 'CKEDITOR'},
      {state: 'wysiwyg', name: 'WYSIWYG EDITOR'}
    ]
  } */

];

@Injectable()
export class MenuItems {

  dashboard_menu = {
    state: 'home',
    name: 'Dashboard',
    type: 'link',
    icon: 'home'
  };

  report_menu = {
    state: 'report',
    name: 'Report',
    type: 'sub',
    icon: 'create',
    children: [
      { state: 'create-new-visura', name: 'Crea nuovo visura' },
      { state: 'create-new-report', name: 'Crea nuovo report' },
      { state: 'report-history', name: 'Storico dei Report' },
      { state: 'candidate-list', name: 'Tutte le Visure' }
    ]
  };

  admin_report_menu = {
    state: 'report',
    name: 'Report',
    type: 'sub',
    icon: 'create',
    children: [
      { state: 'report-history', name: 'Storico dei Report' },
      { state: 'candidate-list', name: 'Tutte le Visure' }
    ]
  };

  consumption_menu = {
    state: 'consumption',
    name: 'Fatturazione e Consumi',
    type: 'sub',
    icon: 'data_usage',
    children: [
      /* { state: 'month', name: 'Consumi del mese' }, */
      /* { state: 'unpaid', name: 'Consumi da pagare' }, */
      { state: 'all', name: 'Tutti i Consumi' },
      { state: 'bill', name: 'Fatture'}
    ]
  };

  file_menu = {
    state: 'file',
    name: 'Carica o scarica File',
    type: 'sub',
    icon: 'cloud_upload',
    children: [
      { state: 'list', name: 'Carica File' },
      /* { state: 'download', name: 'Scarica File' } */
    ]
  };

  profile_menu = {
    state: 'profile',
    name: 'Informazioni Generali',
    type: 'sub',
    icon: 'person',
    children: [
      { state: 'personal', name: 'Informazioni personali' },
      { state: 'company', name: 'Informazioni aziendali' },
      { state: 'contract', name: 'Contratti firmati' },
      { state: 'password', name: 'Cambia password' }]
  };

  admin_profile_menu = {
    state: 'admin',
    name: 'Informazioni Generali',
    type: 'sub',
    icon: 'person',
    children : [
      { state: 'personal', name: 'Informazioni personali' },
      { state: 'password', name: 'Cambia password' }]
  }

  help_menu = {
    state: 'help',
    name: 'Aiuto',
    type: 'link',
    icon: 'help'
  };

  user_menu = {
    state: 'user',
    name: 'HR utenti',
    type: 'link',
    icon: 'person'
  }

  tenant_menu = {
    state: 'tenant',
    name: 'Tenant',
    type: 'link',
    icon: 'tab'
  };

  HR_USER_MENU = [
    this.dashboard_menu,
    this.report_menu,
    this.consumption_menu,
    this.file_menu,
    this.profile_menu,
    this.help_menu
  ];

  ADMIN_USER_MENU = [
    this.dashboard_menu,
    this.admin_report_menu,
    this.consumption_menu,
    this.file_menu,
    this.user_menu,
    this.admin_profile_menu,
    this.help_menu
  ];

  constructor(
    private auth: AuthService
  ) { }

  getAll(): Menu[] {
    if (this.auth.isAdmin()) {
      return this.ADMIN_USER_MENU;
    } else {
      return this.HR_USER_MENU;
    }
  }

  add(menu: Menu) {
    MENUITEMS.push(menu);
  }
}
